


// import React, { useEffect, useState } from 'react';
// import {
//   Box, Typography, Button, Dialog, DialogActions,
//   DialogContent, DialogTitle, TextField, IconButton,
//   LinearProgress, Checkbox, FormControlLabel,
// } from '@mui/material';
// import { Delete, Edit } from '@mui/icons-material';
// import TableComponent from '../../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../../config';
// import api from '../../../api/axiosInterceptor';
// import axios from 'axios';

// export const SuperStaffCircularNotificationComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedCircular, setSelectedCircular] = useState(null);

//   const [formData, setFormData] = useState({
//     subject: '',
//     date_of_issue: '',
//     language: '',
//     is_internal: false, // new field added here
//   });

//   const [selectedFile, setSelectedFile] = useState(null);
//   const [formErrors, setFormErrors] = useState({});

//   const [uploading, setUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);

//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteCircular, setDeleteCircular] = useState(null);

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     { id: 'subject', field: 'subject', headerName: 'Subject', width: 250 },
//     { id: 'dateOfIssue', field: 'dateOfIssue', headerName: 'Date Of Issue', width: 150 },
//     { id: 'language', field: 'language', headerName: 'Language', width: 150 },
//     {
//       id: 'links',
//       field: 'links',
//       headerName: 'Links',
//       width: 120,
//       renderCell: (params) =>
//         params.value ? (
//           <a href={params.value} target="_blank" rel="noopener noreferrer">
//             Download
//           </a>
//         ) : (
//           'No File'
//         ),
//     },
//     {
//       id: 'actions',
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchCirculars();
//   }, []);

//   const fetchCirculars = () => {
//     setLoading(true);
//     axios
//       .get(`${API_BASE_URL}/home-notification/staff-circular/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           subject: item.subject,
//           dateOfIssue: item.date_of_issue,
//           language: item.language,
//           links: item.link || '',
//           is_internal: item.is_internal || false, // include if needed for display
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch circular notification data:', error);
//         setSnackbarMessage('Failed to load circular notification data.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAddCircular = () => {
//     setIsEditMode(false);
//     setFormData({ subject: '', date_of_issue: '', language: '', is_internal: false });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (circular) => {
//     setIsEditMode(true);
//     setSelectedCircular(circular);
//     setFormData({
//       subject: circular.subject,
//       date_of_issue: circular.dateOfIssue,
//       language: circular.language,
//       is_internal: circular.is_internal || false,
//     });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (circular) => {
//     setDeleteCircular(circular);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api
//       .delete(`${API_BASE_URL}/home-notification/circular/${deleteCircular.id}/`)
//       .then(() => {
//         setSnackbarMessage('Circular/Notification deleted successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchCirculars();
//       })
//       .catch((error) => {
//         console.error('Delete failed:', error);
//         setSnackbarMessage('Failed to delete circular notification.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteCircular(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.subject?.trim()) errors.subject = 'Subject is required';
//     if (!formData.date_of_issue) errors.date_of_issue = 'Date is required';
//     if (!formData.language?.trim()) errors.language = 'Language is required';
//     if (!selectedFile && !isEditMode) errors.file = 'File is required'; 
//     if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file && file.size > 2 * 1024 * 1024) {
//       setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 2MB' }));
//       setSelectedFile(null);
//     } else {
//       setFormErrors((prev) => ({ ...prev, file: null }));
//       setSelectedFile(file);
//     }
//   };

//   const handleFormSubmit = async () => {
//     if (!validateForm()) return;

//     const form = new FormData();
//     form.append('subject', formData.subject);
//     form.append('date_of_issue', formData.date_of_issue);
//     form.append('language', formData.language);
//     form.append('is_internal', formData.is_internal);
//     if (selectedFile) form.append('link', selectedFile);

//     try {
//       setUploading(true);
//       setUploadProgress(0);

//       if (isEditMode) {
//         await api.patch(`${API_BASE_URL}/home-notification/circular/${selectedCircular.id}/`, form, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           onUploadProgress: (e) => {
//             setUploadProgress(Math.round((e.loaded * 100) / e.total));
//           },
//         });
//         setSnackbarMessage('Circular/Notification updated successfully.');
//       } else {
//         await api.post(`${API_BASE_URL}/home-notification/circular/`, form, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           onUploadProgress: (e) => {
//             setUploadProgress(Math.round((e.loaded * 100) / e.total));
//           },
//         });
//         setSnackbarMessage('Circular/Notification added successfully.');
//       }

//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//       fetchCirculars();
//       setOpenFormDialog(false);
//     } catch (error) {
//       console.error('Submit failed:', error);
//       setSnackbarMessage('Failed to submit circular notification.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setUploading(false);
//       setUploadProgress(0);
//     }
//   };

//   if (loading) return <LoadingSpinner size={30} />;

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195, 234, 203, 0.1)" p={2}>
//         <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
//           Admin Circular/Notification
//         </Typography>
//         <Button variant="contained" color="primary" onClick={handleAddCircular} disabled={uploading}>
//           Add Circular
//         </Button>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort
//         sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
//       />

//       <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
//         <DialogTitle>{isEditMode ? 'Edit Circular' : 'Add Circular'}</DialogTitle>
//         <DialogContent>
//           <TextField
//             margin="dense"
//             label="Subject"
//             fullWidth
//             value={formData.subject}
//             error={!!formErrors.subject}
//             helperText={formErrors.subject}
//             onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Date of Issue"
//             type="date"
//             fullWidth
//             value={formData.date_of_issue}
//             error={!!formErrors.date_of_issue}
//             helperText={formErrors.date_of_issue}
//             onChange={(e) => setFormData({ ...formData, date_of_issue: e.target.value })}
//             InputLabelProps={{ shrink: true }}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Language"
//             fullWidth
//             value={formData.language}
//             error={!!formErrors.language}
//             helperText={formErrors.language}
//             onChange={(e) => setFormData({ ...formData, language: e.target.value })}
//             disabled={uploading}
//           />
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={formData.is_internal}
//                 onChange={(e) => setFormData({ ...formData, is_internal: e.target.checked })}
//                 disabled={uploading}
//               />
//             }
//             label="Is Internal"
//           />
//           <Box mt={2}>
//             <input
//               accept="*"
//               style={{ display: 'block', marginTop: '8px' }}
//               id="file-upload"
//               type="file"
//               onChange={handleFileChange}
//               disabled={uploading}
//             />
//             {formErrors.file && (
//               <Typography variant="body2" color="error">
//                 {formErrors.file}
//               </Typography>
//             )}
//             {isEditMode && !selectedFile && selectedCircular?.links && (
//               <Typography variant="body2" sx={{ mt: 1 }}>
//                 Current File:{' '}
//                 <a href={`${API_BASE_URL}${selectedCircular.links}`} target="_blank" rel="noopener noreferrer">
//                   Download
//                 </a>
//               </Typography>
//             )}
//           </Box>
//           {uploading && (
//             <Box sx={{ mt: 2 }}>
//               <LinearProgress variant="determinate" value={uploadProgress} />
//               <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
//                 Uploading... {uploadProgress}%
//               </Typography>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>
//             Cancel
//           </Button>
//           <Button variant="contained" color="primary" onClick={handleFormSubmit} disabled={uploading}>
//             {uploading ? <LoadingSpinner size={20} /> : isEditMode ? 'Update' : 'Add'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>Are you sure you want to delete this circular?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>
//             Cancel
//           </Button>
//           <Button variant="contained" color="error" onClick={handleDelete} disabled={uploading}>
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
//     </Box>
//   );
// };



import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
  LinearProgress, Checkbox, FormControlLabel,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../../Components/spinner/spinner';
import { API_BASE_URL } from '../../../config';
import api from '../../../api/axiosInterceptor';
import axios from 'axios';

export const SuperStaffCircularNotificationComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedCircular, setSelectedCircular] = useState(null);

  const [formData, setFormData] = useState({
    subject: '',
    date_of_issue: '',
    language: '',
    is_internal: false,
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteCircular, setDeleteCircular] = useState(null);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    {
      id: 'type',
      field: 'type',
      headerName: 'Type',
      width: 100,
      renderCell: (params) => (
        <Typography variant="body2" fontWeight="bold" color={params.value === 'Staff' ? 'primary.main' : 'secondary.main'}>
          {params.value}
        </Typography>
      ),
    },
    { id: 'subject', field: 'subject', headerName: 'Subject', width: 250 },
    { id: 'dateOfIssue', field: 'dateOfIssue', headerName: 'Date Of Issue', width: 150 },
    { id: 'language', field: 'language', headerName: 'Language', width: 120 },
    {
      id: 'internal',
      field: 'is_internal',
      headerName: 'Internal',
      width: 90,
      renderCell: (params) => (
        <Checkbox checked={params.value} disabled size="small" />
      ),
    },
    {
      id: 'links',
      field: 'links',
      headerName: 'Links',
      width: 120,
      renderCell: (params) =>
        params.value ? (
          <a href={params.value} target="_blank" rel="noopener noreferrer">
            Download
          </a>
        ) : (
          'No File'
        ),
    },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchCirculars();
  }, []);

  // ONLY fetchCirculars is modified to get from both APIs
  const fetchCirculars = async () => {
    setLoading(true);
    
    try {
      const [staffResponse, publicResponse] = await Promise.all([
        axios.get(`${API_BASE_URL}/home-notification/staff-circular/`),
        axios.get(`${API_BASE_URL}/home-notification/circular/`)
      ]);

      const staffData = staffResponse.data.map((item, index) => ({
        id: item.id || index,
        slNo: index + 1,
        subject: item.subject,
        dateOfIssue: item.date_of_issue,
        language: item.language,
        links: item.link || '',
        is_internal: item.is_internal || true,
        type: 'Staff'
      }));

      const publicData = publicResponse.data.map((item, index) => ({
        id: item.id || staffData.length + index,
        slNo: staffData.length + index + 1,
        subject: item.subject,
        dateOfIssue: item.date_of_issue,
        language: item.language,
        links: item.link || '',
        is_internal: item.is_internal || false,
        type: 'Public'
      }));

      const combinedData = [...staffData, ...publicData];
      setRows(combinedData);
    } catch (error) {
      console.error('Failed to fetch circular notification data:', error);
      setSnackbarMessage('Failed to load circular notification data.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAddCircular = () => {
    setIsEditMode(false);
    setFormData({ subject: '', date_of_issue: '', language: '', is_internal: false });
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleEdit = (circular) => {
    setIsEditMode(true);
    setSelectedCircular(circular);
    setFormData({
      subject: circular.subject,
      date_of_issue: circular.dateOfIssue,
      language: circular.language,
      is_internal: circular.is_internal || false,
    });
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (circular) => {
    setDeleteCircular(circular);
    setDeleteDialogOpen(true);
  };

  // Uses ORIGINAL API endpoints for delete (same as before)
  const handleDelete = () => {
    api
      .delete(`/home-notification/circular/${deleteCircular.id}/`)
      .then(() => {
        setSnackbarMessage('Circular/Notification deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchCirculars();
      })
      .catch((error) => {
        console.error('Delete failed:', error);
        setSnackbarMessage('Failed to delete circular notification.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteCircular(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.subject?.trim()) errors.subject = 'Subject is required';
    if (!formData.date_of_issue) errors.date_of_issue = 'Date is required';
    if (!formData.language?.trim()) errors.language = 'Language is required';
    if (!selectedFile && !isEditMode) errors.file = 'File is required'; 
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 2MB' }));
      setSelectedFile(null);
    } else {
      setFormErrors((prev) => ({ ...prev, file: null }));
      setSelectedFile(file);
    }
  };

  // Uses ORIGINAL API endpoints for create/update (same as before)
  const handleFormSubmit = async () => {
    if (!validateForm()) return;

    const form = new FormData();
    form.append('subject', formData.subject);
    form.append('date_of_issue', formData.date_of_issue);
    form.append('language', formData.language);
    form.append('is_internal', formData.is_internal);
    if (selectedFile) form.append('link', selectedFile);

    try {
      setUploading(true);
      setUploadProgress(0);

      if (isEditMode) {
        await api.patch(`/home-notification/circular/${selectedCircular.id}/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (e) => {
            setUploadProgress(Math.round((e.loaded * 100) / e.total));
          },
        });
        setSnackbarMessage('Circular/Notification updated successfully.');
      } else {
        await api.post(`/home-notification/circular/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (e) => {
            setUploadProgress(Math.round((e.loaded * 100) / e.total));
          },
        });
        setSnackbarMessage('Circular/Notification added successfully.');
      }

      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      fetchCirculars();
      setOpenFormDialog(false);
    } catch (error) {
      console.error('Submit failed:', error);
      setSnackbarMessage('Failed to submit circular notification.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  if (loading) return <LoadingSpinner size={30} />;

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195, 234, 203, 0.1)" p={2}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
          Admin Circular/Notification (All)
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAddCircular} disabled={uploading}>
          Add Circular
        </Button>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
      />

      <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
        <DialogTitle>{isEditMode ? 'Edit Circular' : 'Add Circular'}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Subject"
            fullWidth
            value={formData.subject}
            error={!!formErrors.subject}
            helperText={formErrors.subject}
            onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Date of Issue"
            type="date"
            fullWidth
            value={formData.date_of_issue}
            error={!!formErrors.date_of_issue}
            helperText={formErrors.date_of_issue}
            onChange={(e) => setFormData({ ...formData, date_of_issue: e.target.value })}
            InputLabelProps={{ shrink: true }}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Language"
            fullWidth
            value={formData.language}
            error={!!formErrors.language}
            helperText={formErrors.language}
            onChange={(e) => setFormData({ ...formData, language: e.target.value })}
            disabled={uploading}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.is_internal}
                onChange={(e) => setFormData({ ...formData, is_internal: e.target.checked })}
                disabled={uploading}
              />
            }
            label="Is Internal (Staff Only)"
          />
          <Box mt={2}>
            <input
              accept="*"
              style={{ display: 'block', marginTop: '8px' }}
              id="file-upload"
              type="file"
              onChange={handleFileChange}
              disabled={uploading}
            />
            {formErrors.file && (
              <Typography variant="body2" color="error">
                {formErrors.file}
              </Typography>
            )}
            {isEditMode && !selectedFile && selectedCircular?.links && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Current File:{' '}
                <a href={selectedCircular.links} target="_blank" rel="noopener noreferrer">
                  Download
                </a>
              </Typography>
            )}
          </Box>
          {uploading && (
            <Box sx={{ mt: 2 }}>
              <LinearProgress variant="determinate" value={uploadProgress} />
              <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
                Uploading... {uploadProgress}%
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleFormSubmit} disabled={uploading}>
            {uploading ? <LoadingSpinner size={20} /> : isEditMode ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this circular?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleDelete} disabled={uploading}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
    </Box>
  );
};
